// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { RecordLinkItemValue } from '@fulcrumapp/fulcrum-core';
import { queue } from 'async';
import { XIcon } from '../../icons';
import { AppContext } from '../../hooks/use-app';

const fetchQueue = queue(({ item, dataSource }, callback) => {
  item.load(dataSource, callback);
}, 5);

export default class RecordLinkElementItemView extends React.Component {
  static propTypes = {
    editing: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    item: PropTypes.instanceOf(RecordLinkItemValue).isRequired,
    onClick: PropTypes.func.isRequired,
    onRemoveClick: PropTypes.func.isRequired,
  };

  static contextType = AppContext;

  constructor(props, context) {
    super(props, context);

    this.state = {
      unavailable: false,
    };
  }

  componentDidMount() {
    this.fetchRecord();
  }

  componentDidUpdate() {
    this.fetchRecord();
  }

  render() {
    const { styles } = RecordLinkElementItemView;

    return (
      <div
        className={styles.container}
        onClick={this.handleClick}
      >
        <div className={styles.title}>
          {this.label}
        </div>
        {this.renderDeleteButton()}
      </div>
    );
  }

  renderDeleteButton() {
    if (!this.props.editing || this.props.disabled) {
      return null;
    }

    const { styles } = RecordLinkElementItemView;

    return (
      <div
        className={css(styles.remove)}
        onClick={this.handleRemoveClick}
      >
        <XIcon className={css(styles.removeIcon)} />
      </div>
    );
  }

  handleRemoveClick = (event) => {
    event.stopPropagation();

    this.props.onRemoveClick(this.props.item);
  };

  handleClick = (event) => {
    event.stopPropagation();

    if (this.state.unavailable) {
      return;
    }

    this.props.onClick(this.props.item);
  };

  get label() {
    if (this.state.unavailable) {
      return 'Record Unavailable';
    }

    if (this.props.item.record) {
      return this.props.item.displayValue || 'Untitled Record';
    }

    return 'Loading...';
  }

  fetchRecord() {
    if (this._fetching || this.props.item.record || this.state.unavailable) {
      return;
    }

    if (!this.props.item.parent.element.form) {
      this.setState({ unavailable: true });
      return;
    }

    this._fetching = true;

    fetchQueue.push({ item: this.props.item, dataSource: this.context.dataSource }, (err) => {
      this._fetching = false;

      this.setState({ unavailable: err != null });
    });
  }
}

const styles = cssInJS({
  container: {
    display: 'flex',
    marginTop: 6,
    marginBottom: 6,
    padding: 6,
    border: '1px solid #ccc',
    backgroundColor: '#e9e9e9',
    cursor: 'pointer',
    borderRadius: 5,
  },

  title: {
    flex: 1,
  },

  remove: {
    width: 16,
    height: 16,
    cursor: 'pointer',
    fill: '#555',
    transition: 'fill 300ms ease',

    ':hover': {
      fill: '#f00',
    },
  },

  removeIcon: {
    width: 16,
    height: 16,
  },
});

RecordLinkElementItemView.styles = styles;
